export enum SmartDealPromptPayChangeStatus {
    Approve = 'Approve',
    Reject = 'Reject'
}